import { withForm } from "..";
import _SimpleText from "./simple-text";
import _SimpleType from "./simple-type";
import _PrefectureSelect from "./prefecture-select";
import _EmailText from "./email-text";
import _DateText from "./date-text";
import _RelationshipType from "./relationship-type";
import _TelType from "./tel-type";
import _TelText from "./tel-text";
import _PostalcodeText from "./postalcode-text";
import _PaymentMethodType from "./payment-method-type";
import _PayoffType from "./payoff-type";
import _WatertapText from "./watertap-text";
import _ConfirmationCheck from "./confirmation-check";
import _ReservationCodeText from "./reservation-code-text";

export const SimpleText = withForm(_SimpleText);
export const SimpleType = withForm(_SimpleType);
export const PrefectureSelect = withForm(_PrefectureSelect);
export const EmailText = withForm(_EmailText);
export const DateText = withForm(_DateText);
export const RelationshipType = withForm(_RelationshipType);
export const TelType = withForm(_TelType);
export const TelText = withForm(_TelText);
export const PostalcodeText = withForm(_PostalcodeText);
export const PaymentMethodType = withForm(_PaymentMethodType);
export const PayoffType = withForm(_PayoffType);
export const WatertapText = withForm(_WatertapText);
export const ConfirmationCheck = withForm(_ConfirmationCheck);
export const ReservationCodeText = withForm(_ReservationCodeText);
